import React from 'react';
import EnvironmentsTable from '../components/tables/EnvironmentsTable';

const Environments: React.FC = () => {
  return <EnvironmentsTable />;
};

export default Environments;
